'use strict';

exports.SD = require('./SD');
exports.NMR = require('./NMR');
exports.NMR2D = require('./NMR2D');
exports.Ranges = require('./range/Ranges');
exports.GUI = require('./range/visualizer/index');



//////////////////
// WEBPACK FOOTER
// ./~/spectra-data/src/index.js
// module id = 61
// module chunks = 0